
export class Competencia {
    competenciaid: number = 0;
    nombre: string = "";
    descripcion: string = "";
    color: string = "";
    orden!:number;
    activo: boolean = true;

    constructor(init?: Partial<Competencia>) {
        Object.assign(this, init);
    }
}
